var m = require('mithril');
var loaders = require('./loaders');
var io = require('../../libs/socketio');

var usersOnlineMonitor = {};

usersOnlineMonitor.users = [];
usersOnlineMonitor.count = 0;
usersOnlineMonitor.activeRequestCount = 0;
usersOnlineMonitor.lastSnapshotAt = 0;

function applyPayload(payload) {
  if (!payload || !Array.isArray(payload.users)) return false;
  var snapshotAt = Number(payload.snapshotAt);
  if (Number.isFinite(snapshotAt) && snapshotAt < usersOnlineMonitor.lastSnapshotAt) {
    return true;
  }
  usersOnlineMonitor.users = payload.users;
  usersOnlineMonitor.count = Number.isFinite(payload.count) ? payload.count : payload.users.length;
  if (Number.isFinite(snapshotAt)) usersOnlineMonitor.lastSnapshotAt = snapshotAt;
  m.redraw();
  return true;
}

usersOnlineMonitor.getUsers = function () {
  if (usersOnlineMonitor.users.length) {
    return Promise.resolve(usersOnlineMonitor.users);
  }
  return usersOnlineMonitor.requestUsers();
};

usersOnlineMonitor.requestUsers = function () {
  usersOnlineMonitor.activeRequestCount++;
  return loaders.requestWithLoader({
    loader: 'background',
    method: 'GET',
    url: '/api/v1/users/online'
  })
  .then(function (response) {
    applyPayload(response || {});
    return usersOnlineMonitor.users;
  })
  .catch(function (err) {
    console.error('Failed to load online users', err);
    return usersOnlineMonitor.users;
  })
  .finally(function () {
    usersOnlineMonitor.activeRequestCount = Math.max(0, usersOnlineMonitor.activeRequestCount - 1);
  });
};

usersOnlineMonitor.handleUpdate = function (payload) {
  if (applyPayload(payload)) return;
  return usersOnlineMonitor.requestUsers();
};

io.on('users_online:update', usersOnlineMonitor.handleUpdate);

module.exports = usersOnlineMonitor;
